<script setup lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '@/stores/ui'

/**
 * 루트. 화면은 라우터가 그리고, 여기서는 **언어와 문서 속성만** 맞춘다.
 *
 * 언어를 스토어와 i18n 두 곳에 두는 이유: 스토어는 저장·API 헤더를 담당하고
 * i18n 은 렌더를 담당한다. 한쪽만 바꾸면 화면은 영어인데 서버 알림이 한국어로
 * 오는 상태가 된다 — 실제로 겪은 버그다.
 */
const ui = useUiStore()
const { locale } = useI18n()

watch(
  () => ui.locale,
  (next) => {
    locale.value = next
    document.documentElement.lang = next
  },
  { immediate: true },
)

watch(
  () => ui.theme,
  () => ui.applyTheme(),
  { immediate: true },
)
</script>

<template>
  <RouterView />
</template>
